import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 overflow-hidden pt-20" data-id="element-19">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-20">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-purple-600/20 rounded-full blur-3xl" data-id="element-21" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-indigo-600/20 rounded-full blur-3xl" data-id="element-22" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-23">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-6" data-id="element-24">
          Discover Your Next <br data-id="element-25" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-400 to-pink-400" data-id="element-26">
            Investment Opportunity
          </span>
        </h1>

        <p className="text-lg md:text-xl text-purple-100/80 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-27">
          Integrated platform connecting innovative startups with strategic
          investors. Smart matching, automated evaluation, and network
          integration.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-28">
          <button className="w-full sm:w-auto px-8 py-4 bg-emerald-500 hover:bg-emerald-400 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-lg shadow-emerald-900/20 flex items-center justify-center gap-2" data-id="element-29">
            Submit Your Startup
            <ArrowRight size={20} data-id="element-30" />
          </button>

          <button className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/20 hover:bg-white/10 text-white font-semibold rounded-lg transition-all flex items-center justify-center" data-id="element-31">
            Investor Login
          </button>
        </div>
      </div>
    </section>;
}